<iframe
  style="height: 100%; width: 100%; border: none; display: block"
  [src]="legalUrl"
>
</iframe>
